import React from "react";

const PortalMainPageButtons = ({ dispatch, roles }) => {
    // Edit this array to change the buttons listed in the main home page of the portal.
    const mainPageButtonListArray = [
        {
            name: "Make Referral",
            href: "#icon-assign-clinician",
            componentName: "ReferralClientList",
            breadCrumb: "Home / Make Referral",
            hasRole: containsRole("Referrer"),
        },
        {
            name: "View MI Reports",
            href: "#icon-patient",
            componentName: "ViewMIReports",
            breadCrumb: "Home / View MI Reports",
            hasRole: containsRole("MIReports"),
        },
        {
            name: "MyIprsHealth",
            href: "#icon-ia",
            componentName: "AccessMyIprsHealth",
            breadCrumb: "Home / My IprsHealth",
            hasRole: containsRole("MyIprsHealthAccess"),
        },
    ];

    function containsRole(role) {
        const includes = roles?.some((str) => str.includes(role));
        return includes ?? false;
    }

    // This dispatch is used, and type + payload is given and it will be triggered in the parent component.
    const mainPageButtonHandler = (obj) => {
        console.log(obj);
        dispatch({
            type: "SET_PAGE",
            payload: {
                componentName: obj.componentName,
                breadCrumb: obj.breadCrumb,
            },
        });
    };

    return (
        <div className="iprsPortalMainPageButtonList">
            {mainPageButtonListArray.map(
                (buttonObj, i) =>
                    buttonObj.hasRole && (
                        <div
                            className="iprsPortalMainPageButtonDiv"
                            onClick={() => mainPageButtonHandler(buttonObj)}
                            key={i + buttonObj.name}
                        >
                            <div className="dashboard-ctas__icon">
                                <svg width="63" height="60">
                                    <use href={buttonObj.href} />
                                </svg>
                            </div>
                            <span>
                                {buttonObj.name} {" " + ">"}
                            </span>
                        </div>
                    )
            )}
        </div>
    );
};

export default PortalMainPageButtons;
